// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"theme--wrapper--3bpx_HPV","isBlock":"theme--isBlock--2R1s2H-C","button":"theme--button--x7M5CWsg","is-primary":"theme--is-primary--1PR2yZEz","isPrimary":"theme--is-primary--1PR2yZEz","is-danger":"theme--is-danger--3o6q6mEW","isDanger":"theme--is-danger--3o6q6mEW","is-raised":"theme--is-raised--3MtMwXIZ","isRaised":"theme--is-raised--3MtMwXIZ","is-flat":"theme--is-flat--1GlRt6zW","isFlat":"theme--is-flat--1GlRt6zW","is-disabled":"theme--is-disabled--zpYOr4JQ","isDisabled":"theme--is-disabled--zpYOr4JQ"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/sign/baseComponents/Button/theme.scss
// module id = 815
// module chunks = 0